import moment from 'moment-timezone';

import { RfqSessionBidPricingComponent } from './rfq-session-bid-pricing-component';
import { RfqSessionProduct } from './rfq-session-product';
import { RfqSessionSupplier } from './rfq-session-supplier';

export class RfqSessionBid {
	public rfqSessionBidId: string;
	public bandwidthPercentage: number;
	public salesTax: number;
	public rfqSessionSupplierId: string;
	public ipAddress: string;
	public billingMethod: string;
	public rfqSessionId: string;
	public debug: string;
	public addDate: string | Date;
	public amount: number;
	public addDate2: string | Date;
	public rfqSessionProductId: string;
	public isGRTIncluded: boolean;
	public units: string;
	public bufferMargin: number;
	public rfqSessionBidStatusId: number;
	public displayRate: number;
	public packingMargin: number;
	public isOnHold: boolean;

	public rfqSessionProduct: RfqSessionProduct;
	public pricingComponents: RfqSessionBidPricingComponent[];
	public rfqSessionSupplier: RfqSessionSupplier;

	// internal use
	public removing: boolean;

	constructor(rfqSessionBid?: RfqSessionBid) {
		Object.assign(this, rfqSessionBid);

		this.addDate = this.addDate ? new Date(moment(this.addDate).format('MMM DD, YYYY hh:mm:ss a')) : this.addDate;
		this.addDate2 = this.addDate2 ? new Date(moment(this.addDate2).format('MMM DD, YYYY hh:mm:ss a')) : this.addDate2;

		if (this.rfqSessionSupplier) {
			this.rfqSessionSupplier = new RfqSessionSupplier(this.rfqSessionSupplier);
		}
	}
}
